<!-- Header HTML Start -->
<app-header></app-header>
<!-- Header HTML End -->


<section class="terms">
  <div class="terms-banner b5containeradjust" style="background-image: url(assets/images/profile_header.png);">
    <div class="container">
      <div class="d-flex flex-wrap align-items-center px-md-0 px-3">
        <div class="col-md-9 col-8 no-space-right">
          <h1 class="page-caption text-white m-0">Terms and Conditions</h1>
        </div>
        <div class="col-md-3 text-end col-4">
          <i class="terms-banner-icon">
            <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="40px"
              viewBox="0 0 512 512" width="40px" class="">
              <g>
                <g>
                  <path
                    d="m446.606 104.394-100-100c-2.813-2.813-6.628-4.394-10.606-4.394h-220c-30.327 0-55 24.673-55 55v402c0 30.327 24.673 55 55 55h280c30.327 0 55-24.673 55-55v-342c0-3.978-1.581-7.793-4.394-10.606zm-95.606-53.181 48.787 48.787h-48.787zm45 430.787h-280c-13.785 0-25-11.215-25-25v-402c0-13.785 11.215-25 25-25h205v85c0 8.284 6.716 15 15 15h85v327c0 13.785-11.215 25-25 25z"
                    data-original="#000000" class="active-path" data-old_color="#000000" fill="#e59a2c" />
                  <path
                    d="m356 202c-18.955 0-35.996-10.532-44.472-27.484l-2.111-4.223c-2.541-5.083-7.735-8.293-13.417-8.293h-80c-5.682 0-10.876 3.21-13.417 8.292l-2.111 4.222c-8.476 16.954-25.517 27.486-44.472 27.486-8.284 0-15 6.716-15 15v85.597c0 33.654 10.619 65.715 30.708 92.716 20.089 27 47.747 46.384 79.982 56.054 1.406.422 2.858.633 4.31.633s2.904-.211 4.31-.633c32.235-9.67 59.893-29.054 79.982-56.054 20.089-27.001 30.708-59.062 30.708-92.716v-85.597c0-8.284-6.716-15-15-15zm-15 100.597c0 54.256-33.971 101.385-85 118.66-51.029-17.275-85-64.404-85-118.66v-71.995c22.701-4.285 42.437-18.2 54.125-38.603h61.75c11.688 20.402 31.424 34.318 54.125 38.603z"
                    data-original="#000000" class="active-path" data-old_color="#000000" fill="#e59a2c" />
                  <path
                    d="m287.82 268.109-45.962 45.961-17.678-17.677c-5.857-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l28.284 28.284c2.929 2.929 6.768 4.394 10.606 4.394s7.678-1.464 10.606-4.394l56.568-56.568c5.858-5.858 5.858-15.355 0-21.213-5.856-5.858-15.354-5.858-21.211 0z"
                    data-original="#000000" class="active-path" data-old_color="#000000" fill="#e59a2c" />
                </g>
              </g>
            </svg>
          </i>
        </div>
      </div>
    </div>
  </div>

  <div class="terms-hld b5containeradjust pt-md-5 pt-3 ">
    <div class="container">
      <div class="d-flex">
        <div class="col-md-12 px-3">
          <div class="editor-hld">
            <h2>JUSTMONEY SUBSCRIPTION AGREEMENT</h2>

            <h2 #contracting>1. Who you are contracting with</h2>

            <p>We are JustMoney, a division of Justmoney (Pty) Ltd. We own and run the JustMoney service, website <a
                href="https://www.justmoney.co.za/">www.justmoney.co.za</a>
              and JustMoney Platform <a href="https://app.justmoney.co.za">https://app.justmoney.co.za</a>
            </p>
            <p>Justmoney (Pty) Ltd is a 100% subsidiary of New IDM Holdings (RF) (Pty) Ltd.</p>


            <h2 #service>2. Scope of this Agreement</h2>
            <p>2.1 This Subscription Agreement is between you ("you / the Subscriber") and JustMoney (Pty) Limited,
              registration number 2007/011821/07 ("JustMoney / us / we").
            </p>
            <p>2.2 This Agreement contains the legal terms that apply to your use of the various services, products and
              tools offered to you via the JustMoney website and/or JustMoney Platform. </p>

            <h2 #verifyIdentity>3. Preliminary notices in terms of the Consumer Protection Act, 2008</h2>
            <p>There are terms in this Agreement that require your careful consideration. To assist you, those terms
              which may limit your rights or require you to give specific acknowledgements, or warranties have been
              highlighted in capital letters. YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD THE IMPORTANCE OF THESE
              TERMS.</p>


            <h2 #tratpersonalInfo>4. Definitions and interpretation</h2>
            <p>4.1 In this Agreement:</p>
            <p>4.1.1 <strong>“Confidential Information”</strong> means all proprietary and confidential information
              including, without limitation, all Intellectual Property, technical information, business information,
              sales information, product sales plans, marketing and advertising methodologies and strategies,
              inventions, developments, discoveries, know-how, methods, techniques, formulae, data, processes and other
              trade secrets and proprietary ideas, whether or not patentable or copyrightable, which may be developed,
              delivered or communicated by JustMoney to you from time to time pursuant to this Agreement;</p>
            <p>4.1.2 <strong>"Credit Bureaus"</strong> means any registered credit bureau in South Africa, including
              TransUnion, Experian, XDS and VCCB;</p>
            <p>4.1.3 <strong>“Direct Marketing”</strong> means promoting and concluding the sale of any of our products
              or services, either by way of direct mail, electronic mail, internet, media insert, telephone, SMS etc;
            </p>
            <p>
              4.1.4 <strong>“Force Majeure Event”</strong> means any event beyond our reasonable control, including
              without limitation,
              acts of God, war (whether declared or not) , riots, embargoes, acts of civil or military authorities,
              fires, floods, accidents, service outages resulting from equipment and/or software failure and/or
              telecommunications failure, network failures, failures of third party service providers (including
              providers of internet services and telecommunications),any act of terrorism, strikes affecting people
              other than our employees, power outages, any court order, any requirements of any authority or other
              competent local authority, and any governmental legislative or administrative action;
            </p>

            <p>4.1.5 <strong>“Intellectual Property"</strong> means any and all rights to and in connection with any
              patent, design, trademark, copyright, trade secret, and shall include any concepts, idea, methods,
              methodology, procedure, process, know-how, technique, strategy, model, template, database, software and
              business relationship or trade connection which vest in a Party and/or which have been created or acquired
              by a Party or in which it otherwise has rights; and all other identical or similar intellectual property
              as may exist anywhere in the world and any applications for registration of such Intellectual Property;
            </p>
            <p>4.1.6 <strong>"JustMoney Platform"</strong> means the products, services, and tools accessible from
              <a href="https://app.justmoney.co.za"> https://app.justmoney.co.za;</a>
            </p>
            <p>4.1.7 <strong>“Personal Information”</strong> means any information about or relating to you, which is
              required by us to conclude this Agreement and to supply any products or services in terms of this
              Agreement to you, including without limitation:</p>
            <p>4.1.7.1 identity related information (e.g. names, identity number; passport number etc.);</p>
            <p>4.1.7.2 contact information (e.g. residential and work physical and postal addresses; cellphone, home and
              work telephone numbers; email addresses etc.);</p>
            <p>4.1.7.3 demographic information (e.g. age; gender etc.); and</p>
            <p>4.1.7.4 banking information (e.g. bank account; credit card number etc.);</p>
            <p>4.1.8 <strong>“User Profile”</strong> means the unique username and password assigned to users of the
              JustMoney website
              and/or JustMoney Platform, which gives users access to the selected services, products, and tools offered
              by JustMoney; </p>
            <p>4.1.9 <strong>"writing"</strong> means legible writing and in English and includes any form of electronic
              communication
              contemplated in the Electronic Communications and Transactions Act, 25 of 2002.</p>
            <p>4.2 Any period of days prescribed in this agreement must be calculated by excluding the first and
              including the last day. If the last day falls on a Saturday, Sunday or public holiday, then the next
              business day will be regarded as the last day. A <strong>“business day”</strong> means any day which is
              not a Saturday,
              Sunday or public holiday in the Republic of South Africa.</p>
            <p> 4.3 The expiration or termination of this Agreement shall not affect any of the provisions of this
              Agreement as expressly provide that they will operate after any such expiration or termination or which of
              necessity must continue to have effect after such expiration or termination, notwithstanding that the
              clauses themselves do not expressly provide for this.</p>
            <p> 4.4 The rule of construction, that a contract shall be interpreted against the party responsible for the
              drafting or preparation of the contract, shall not apply to this Agreement.
            </p>

            <h2>5. Account registration, access, and use</h2>
            <p>5.1 You must register an account and create a User Profile to access and use the services, products and
              tools made available on the JustMoney Platform.</p>
            <p>5.2 Any registration information that you provide to us must be accurate, current and complete.</p>
            <p>5.3 You must keep the details of your User Profile strictly confidential and secure and you must not
              share these details with any other person. We recommend that you change your password for your account on
              a regular basis.</p>
            <p>5.4 You hereby authorise us to act on any order, request or instruction given via the JustMoney Platform,
              which appears to have been sent by you or on your behalf, even if it subsequently transpires that the
              order, request or instruction was fraudulently submitted by another person. You must notify us immediately
              if you find out or reasonably suspect that someone has engaged in such fraudulent conduct and/or has
              gained unauthorised access to your User Profile details.</p>
            <p>5.5 You must also immediately notify us if you detect any unauthorized use or activity on your account,
              or if your User Profile details have been lost, stolen or misused.</p>
            <p>5.6 We may suspend your use of the JustMoney Platform, or any part thereof, if we have reasonable grounds
              to suspect that the confidentiality of your User Profile details or your account has been compromised or
              breached.</p>
            <p>5.7 Although we use commercially reasonable efforts to make sure the JustMoney website and/or JustMoney
              Platform is available at all times with minimum disruptions, we cannot guarantee that availability.</p>
            <p>5.8 We will not be held liable for any loss or damage caused to you or any third party by the
              non-availability or disrupted availability of the JustMoney Platform or any part thereof.</p>
            <p>5.9 We reserve the right, without any liability, to refuse, limit, suspend or interrupt your access to
              the JustMoney website and/or JustMoney Platform if you do not comply with any of the terms and conditions
              contained in this Agreement, or for any other reason valid in law.
            </p>

            <h2>6. Commencement, duration and cooling off rights</h2>
            <p>6.1 This Agreement will commence on the date that you first access and/or use the JustMoney website
              and/or JustMoney Platform or start using any services or products offered by JustMoney ("commencement
              date"). </p>
            <p>6.2 This Agreement will remain in force and will apply to your use of all services, products or tools on
              the JustMoney Platform from the commencement date. </p>
            <p>6.3 In terms of section 44 of the Electronic Communications and Transactions Act (No.25 of 2002), you may
              cancel any transaction with JustMoney within 7 (seven) days after the commencement date if that
              transaction was pursuant to any Direct Marketing conducted for or on our behalf. </p>
            <p>6.4 Cancellations must be made 72 hours prior to the agreed payment date. Any cancellations made within
              this period will only take effect in the following month. No refunds will be made for any cancellations
              within the 72-hour period.
            </p>


            <h2>7. No offers, orders</h2>
            <p>7.1 You must not regard anything published on the JustMoney website and/or JustMoney Platform as an
              offer, but rather as an invitation to do business.</p>
            <p> 7.2 JustMoney is under no obligation to sell or deliver any products or services advertised on the
              JustMoney website and/or JustMoney Platform until you have registered an account with us and a valid
              subscription for specific products or services has been accepted and activated by us.
            </p>

            <h2>8. Products and services</h2>
            <p>8.1 The full suite of services, products and tools available for subscription from the JustMoney Platform
              are listed in Annexure A.</p>
            <p>8.2 Please note that certain services or products may include other terms which will apply if you
              subscribe for such services or products. These additional terms must be read together with the terms of
              this Agreement.</p>
            <p>8.3 Each of the services, products and tools supplied via the JustMoney website and/or JustMoney Platform
              are, and will always continue to be, in the form and supplied in the manner chosen by JustMoney at its
              sole discretion.</p>
            <p>8.4 All information services and products supplied by JustMoney are strictly for your own personal
              information purposes. They do not constitute financial or other professional advice. If you require
              further advice or guidance, you must engage a qualified professional advisor.</p>
            <p>8.5 You warrant that you will only use our services, products and tools solely for their intended
              purpose, and for no other purpose which has not been authorised by us in writing. JustMoney shall not be
              responsible for the consequences of any unauthorised or unintended use of our services, products or tools.
            </p>
            <p>8.6 You will be solely responsible for any action taken pursuant to your use of any of the services,
              products or tools made available to you.</p>
            <p>8.7 JustMoney shall not be expected to and shall not verify any data given to us either by you, or any
              Credit Bureau, or by any other person.</p>
            <p>8.8 You shall remain solely responsible for taking all decisions, making all enquiries, applying your own
              judgment, and managing all aspects of the products and services you subscribe for, including issues
              relating to financial planning and debt relief.</p>
            <p>8.9 You are responsible for regularly reviewing your credit information and ensuring that it is and
              remains true, accurate, complete, relevant, or current.</p>
            <p>8.10 JustMoney makes no representations and/or gives no guarantees that you will realise any financial
              benefits from your use of any of the services, products or tools accessed from the JustMoney website
              and/or JustMoney Platform.
            </p>

            <h2>9. Third Party Products and links to Third Party Websites</h2>
            <p>9.1 We may publish information about services and products offered and supplied by third party vendors
              and service providers via the JustMoney website and/or JustMoney Platform ("third party products and
              services").</p>
            <p>9.2 If you decide to purchase any third party products and services, you will do so under a separate
              agreement with the relevant vendor or service provider.</p>
            <p>9.3 JustMoney does not offer any warranties or representations regarding any third party products or
              services advertised on the JustMoney website and/or JustMoney Platform. We also do not guarantee the
              suitability of any third party products and services and your use thereof will be entirely at your own
              risk.</p>
            <p>9.4 The JustMoney website and/or JustMoney Platform may also contain links or references to other
              websites, including those of advertisers (“Third Party Websites“) outside of our control. This Agreement
              does not apply to those Third Party Websites and we are not responsible for the practices and/or policies
              of those Third Party Websites.</p>
            <p>9.5 Your use of such third party websites is entirely at your own risk and we are not responsible for any
              loss, expense, claim or damage, whether direct, indirect or consequential, arising from your use of such
              Third Party Websites or your reliance on any information contained thereon.
            </p>

            <h2>10. Protection of Personal Information</h2>
            <p>10.1 You hereby consent to us processing your Personal Information for the purpose of concluding this
              Agreement with you and for complying with our obligations under this Agreement and in terms of any
              applicable laws.
            </p>
            <p>10.2 When processing any personal information about or for you, JustMoney undertakes that:
            </p>
            <p>10.2.1 any processing of personal information carried out by us will be done in compliance with the
              relevant provisions of the Protection of Personal Information Act (No.4 of 2012) and any other applicable
              laws (and, where applicable, any directive given by the Information Regulator);
            </p>
            <p>10.2.2 we shall only process personal information in accordance with your instructions;
            </p>
            <p>10.2.3 we shall implement, adopt and maintain adequate technical and organisational security measures
              which is appropriate to the risks presented by the processing and the nature of the information to be
              protected, in particular where the processing involves the transmission of personal information over a
              network, and in accordance with generally accepted industry practice and having regard to the costs of
              implementing such measures;
            </p>
            <p>10.2.4 we shall not transfer any personal information to another country without prior written consent
              from you, and then only to a country that provides the same or similar protection as set out in the
              Protection of Personal Information Act;
            </p>
            <p>10.2.5 we shall promptly notify you about:
            </p>
            <p>10.2.5.1 any legally binding request for disclosure of the personal information by a law enforcement
              authority unless otherwise prohibited, such as a prohibition under criminal law to preserve the
              confidentiality of a law enforcement investigation;
            </p>
            <p>10.2.5.2 any accidental or unauthorised access to any personal information being processed by us for or
              on your behalf; and
            </p>
            <p>10.2.5.3 any access request received from any person.
            </p>
            <p>10.3 For further information, please consult our<a routerLink="/policy"
                href="https://justmoneycreditsav.co.za/policy" target="_blank">
                Privacy Notice
              </a> .
            </p>

            <h2>11. Intellectual Property</h2>
            <p>11.1 The JustMoney website and/or JustMoney Platform, and all content published on it is owned or
              licenced by JustMoney and is protected under copyright law.
            </p>
            <p>11.2 Subject to your compliance with the terms and conditions of this Agreement, JustMoney grants you a
              limited, non-exclusive, non-transferable, non-sublicensable license to access and make personal and
              non-commercial use of the JustMoney website and/or JustMoney Platform and all the content published on it.
            </p>
            <p>11.3 This license does not entitle you to resell or otherwise make commercial use of JustMoney website
              and/or JustMoney Platform or any of the content published on it; or to create any derivative use of any
              published content, services, products or tools made available by us.
            </p>
            <p>11.4 You acknowledge that JustMoney is the exclusive owner, licensee or authorised user of all
              Intellectual Property in or relating to the services, products and tools made available on the JustMoney
              website and/or JustMoney Platform, including all Confidential Information about or relating thereto and to
              the services, products and tools made available to you.
            </p>

            <h2>12. DISCLAIMERS</h2>
            <p>12.1 The JustMoney website and/or JustMoney Platform, including all published content, services,
              products, and tools made available to you by us, is provided "as is" and "as available".
            </p>
            <p>12.2 JustMoney makes no representations or warranties, express or implied, including but not limited to
              warranties as to the correctness or suitability of the JustMoney website and/or JustMoney Platform or any
              published content, services, products, and tools made available from or contained in it.
            </p>
            <p>12.3 JustMoney, its officers, directors, employees, suppliers, internet service providers, partners,
              affiliates and agents, shall not be liable for any damage, loss or liability, howsoever arising, incurred
              by you or any other person resulting from the use, or inability to use, the JustMoney website and/or
              JustMoney Platform, or any published content, services, products, and tools made available from or
              contained in it (including without limitation direct, indirect, incidental, special, punitive or
              consequential loss, loss of profit or anticipated savings or damages).
            </p>
            <p>12.4 in particular, and without limitating the generality of the exclusion in clause 12.3, JustMoney
              shall not be liable for any damage, loss or liability arising from or relating to any of the following:
            </p>
            <p>12.4.1 your use of any of JustMoney’s services, products or tools other than for their stated purpose;
            </p>
            <p>12.4.2 your use of any information received from one or more of the credit bureaus which is incorrect or
              inaccurate, or has not been updated;
            </p>
            <p>12.4.3 any downtime, outage, interruption in or unavailability of the JustMoney website and/or JustMoney
              Platform, or any of the services, products or tools published in or made available from it which is not
              attributable to any fault on the part of JustMoney, including without limitation –
            </p>
            <p>12.4.3.1 repairs and maintenance carried out in the ordinary course of business;
            </p>
            <p>12.4.3.2 any interruption or loss attributable to any other public or private network operator, content
              provider, database provider, or service provider; and/or
            </p>
            <p>12.4.3.3 any force majeure event.
            </p>
            <p>12.5 JustMoney has no control over any third party information, adverts, features or other materials
              ("Third Party Content") published on or accessible from the JustMoney website and/or JustMoney Platform.
              JustMoney does not examine or edit any Third Party Content and/or does not act as an agent for any third
              party in this regard. As such and to the fullest possible extent permissible under law, JustMoney
              disclaims any liability whatsoever for any loss or damage arising from the use of any Third Party Content.
            </p>

            <h2>13. Consent to jurisdiction</h2>
            <p>13.1 For the purpose of all or any proceedings hereunder the parties consent to the jurisdiction of the
              Magistrate’s Court, notwithstanding that such proceedings are otherwise beyond its jurisdiction.
            </p>
            <p> 13.2 This clause shall be deemed to constitute the required written consent conferring jurisdiction upon
              the said court pursuant to section 45 of the Magistrates' Court Act, 1944, provided, nevertheless, that
              JustMoney shall be entitled, in its sole discretion, to institute such proceedings in the High Court of
              South Africa and, in such event, the Subscriber hereby consents to the jurisdiction of the said court.
            </p>

            <h2>14. Domicilium, notices and electronic communications</h2>
            <p>14.1 You choose as your domicilium citandi et executandi (“Domicilium”) for all purposes relating to this
              Agreement, including the giving of any notice, the payment of any sum, the serving of any process, at your
              residential address or principal place of business as stated in your account registration application or
              as otherwise notified to us from time to time.
            </p>
            <p>14.2 You hereby agree that JustMoney can use any suitable form of electronic communication to communicate
              with you and to deliver any notices in terms of this Agreement.
            </p>
            <p>14.3 Electronic communications, including e-mail, SMS and instant messages, sent by you to the JustMoney
              website and/or JustMoney Platform, or any associated websites, or to us directly will only be deemed to
              have been received when we actually acknowledge receipt or respond to you.
            </p>
            <p>14.4 Electronic communications sent by us to you will be deemed as received by you once the complete
              communication has entered the information system you have designated or use for that purpose, and can be
              retrieved and processed by you.
            </p>

            <h2>15. General</h2>
            <p>15.1 This Agreement is the whole agreement between us. You acknowledge that you have not been induced to
              enter into this Agreement by any representations or warranties, other than those set out in this Agreement
              and that any representations or warranties not contained in this Agreement will have no force or effect.
            </p>
            <p>15.2 If any provision of this Agreement is held to be illegal, invalid or unenforceable for any reason,
              that provision will be severed from this Agreement without affecting, impairing or invalidating any of the
              remaining provisions of this Agreement, which shall continue to be of full force and effect.
            </p>
            <p>15.3 No waiver of any of the terms and conditions of this Agreement will be binding for any purpose
              unless expressed in writing and signed by the party giving the waiver, and that waiver will only be
              effective for the specific purpose it is given for.
            </p>
            <p>15.4 No failure or delay on the part of either party in exercising any right, power or privilege will
              operate as a waiver, nor will any single or partial exercise of any right, power or privilege preclude any
              other or further exercise thereof or the exercise of any other right, power or privilege.
            </p>
            <h2>16. Consumer protection information</h2>
            <p>
              16.1 In compliance with section 43(1) of the Electronic communications and Transaction Act 25 of 2002
              (“ECT Act”), your attention is drawn to the following:
            </p>
            <p>16.1.1 Full name and legal status: JustMoney (Pty) Ltd, trading as JustMoney a private company
              incorporated in accordance with the laws of the Republic of South Africa;
            </p>
            <p>16.1.2 Registration number: 2007/011821/07;
            </p>
            <p>16.1.3 Place of registration: South Africa
            </p>
            <p>16.1.4 Registered physical address: 4th Floor, Mutual Park, 5 Jan Smuts Drive, Pinelands, 7405
            </p>
            <p>16.1.5 Telephone number: : 0875376113
            </p>
            <p>16.1.6 Website: www.JustMoney.co.za
            </p>
            <p>16.1.7 Email address: <a id="anchor-MailToJustmoneyInfo-Policy"
                href="mailto:info@justmoney.co.za">info&#64;justmoney.co.za</a>
            </p>
            <p>16.1.8 Platform: <a href="https://app.justmoney.co.za">https://app.justmoney.co.za</a>
            </p>
            <p>16.1.9 Physical address for receipt of legal documents: 4th Floor, Mutual Park, 5 Jan Smuts Drive,
              Pinelands, 7405
            </p>
            <p>16.1.10 Powered by NCRCB29.
            </p>
            <h2>17. Changes to this Agreement</h2>
            <p>17.1 We may update or modify this Agreement from time to time, including any referenced policies and
              other documents. If any update or modification reduces your rights, we will use reasonable efforts to
              notify you. The modified version of this Agreement will not be effective for existing Orders but will be
              applicable for any Orders executed or services provided by JustMoney after the date that the modification
              is made.</p>
            <p>17.2 We may update or modify this Agreement from time to time, including any referenced policies and
              other documents. If a revision meaningfully reduces your rights, we will use reasonable efforts to notify
              you. If you object to the provisions of any updated or amended version of this Agreement, your exclusive
              remedy is to stop accessing and using the service.</p>



               <h2>Money-Stress Tracker 2025 voucher competition terms and conditions</h2>

               <p>The JustMoney Money and Me survey is an annual survey that measures how South Africans make
                their key financial decisions. Eligible respondents participating in the survey, and who opt in to enter
                the Clicks Voucher Competition, stand a chance to win one of five R5,000 Clicks vouchers, subject to
                the following Terms and Conditions.</p>
                 
               <h2>1. Eligibility</h2>
               <p>The JustMoney Money and Me survey 2025 voucher competition (hereinafter referred to as "the
                Competition") is open to survey respondents, provided they meet the criteria below. Employees of
                Intelligent Debt Management, and their family members, cannot enter the competition.</p>
                <p>To be eligible for entry, the respondent must successfully and fully complete the JustMoney Money
                and Me survey 2025 survey.</p>


                <h2>2. Entry mechanism</h2>
                <p>Entry is by opt-in. Survey respondents are required to enter their details at the end of the survey, in order to enter the competition.</p>

                <h2>3. Competition Period</h2>
                <p>The competition and entries will close on Friday, 19 September 2025. Winners will be chosen in a random draw on <b>Thursday, 25 and Friday, 26 September</b>.</p>

                <h2>4. Winner Selection</h2>
                <p>The winners will be chosen by random draw from among the pool of eligible participants.</p>

                <h2>5. Notification of winners</h2>
                <p>The winners will be announced on the JustMoney platform and all competition entrants will receive an email to invite them to log in to the platform to see whether they are among the winners. JustMoney will announce the names of the winners on a banner on the platform and the winners will also receive a notification email from the JustMoney   team to confirm the results of the competition. Winners will be required to reply to this notification email in order to confirm receipt of the notification. If no confirmation reply is received, the winner/s will be contacted by telephone.</p>
                <p>If a selected winner is not contactable within seven days, a new winner may be selected through a second random draw.</p>
                <p>The voucher will be dispatched via email to the winner, once contact has been established.</p>

                <h2>6. General Conditions</h2>
              <p>6.1. Participation in the Competition constitutes acceptance of these Terms and Conditions.</p>
            <p>6.2. Winners may be required to provide proof of eligibility and identity.</p>
            <p>6.3. The prize is non-transferable and cannot be exchanged for cash or any other form of compensation.</p>
            <p>6.4. Any attempt by a participant to deliberately undermine the legitimate operation of the Competition may be a violation of criminal and civil laws, and should such an attempt be made, the organisers reserve the right to seek damages from any such person to the fullest extent permitted by law.</p>
            <p>6.5. JustMoney reserves the right to modify, suspend, or terminate the Competition at any time without prior notice, for any reason, including but not limited to technical reasons or if fraud or misconduct is suspected.</p>
            <p>6.6. These Terms and Conditions shall be governed by and construed in accordance with the laws of South Africa.</p>
            <p>6.7. JustMoney is not responsible for any technical issues or other problems that may affect entry. JustMoney reserves the right to modify or cancel the competition at any time.</p>


            <h2>7. POPIA Consent Clause</h2>
            <p>7.1 By entering this Competition, you hereby consent to the collection, processing, and storage of your personal information by JustMoney for the sole purpose of administering and managing this Competition, including but not limited to verifying eligibility, selecting and contacting winners, and fulfilling prizes. Your personal information will not be used for any other purpose without your further consent and will be handled in accordance with the Protection of Personal Information Act, 4 of 2013 (POPIA). You have the right to access, update, or request deletion of your personal information at any time.</p>









          </div>

        </div>
      </div>
    </div>
  </div>
</section>


<!-- Contact HTML Start 
  <app-contact></app-contact>-->
<!-- Contact HTML End -->

<!-- Footer HTML Start -->
<app-footer></app-footer>
<!-- Footer HTML End -->